import React, { useEffect, useState } from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';


const plugin1 = {
    id:'plugin1',
    beforeDraw: (chart, args, opts) => {
        if(!opts.background.color || !opts.border.color){
            return;
        }
        const {ctx, chartArea: {left, top, width, height}} = chart;
        ctx.fillStyle = opts.background.color;
        ctx.fillRect(left, top, width, height);

        // ctx.strokeStyle = opts.border.color;
        // ctx.lineWidth = opts.border.width;
        // ctx.strokeRect(left, top, width, height);
    }
}

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    plugin1,
);

function DashboardBarChart({visitorData}) {
    const [chartOption, setChartOption] = useState({});
    const [chartData, setChartData] = useState({});

    useEffect(() => {
        const visiterNumList = visitorData.length ? visitorData.map(e=>e.count) : [];
        const visiterMaxNum = Math.max(...visiterNumList);
        const visiterRatioList = visiterNumList.map(curVisiter => Math.round(curVisiter / visiterMaxNum * 100));
    
        const options = {
            parsing: {
                xAxisKey: 'name',
                yAxisKey: 'count'
            },
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                plugin1:{
                    background: {
                        color: 'white' 
                    },
                    border: {
                        color: '#d3d3d3',
                        width: '1'
                    }
                },
                plugin2: false,
                datalabels: false,
                legend: {
                    display: false
                }     
            },
            scales: {
                x: {
                    grid: {
                        display: false,
                    },
                    ticks: {
                        display: true,
                        font: {
                            weight: 'bold',
                            color: 'black'
                        },
                    },
                },
                y: {
                    border: {
                        display: false,
                    },
                    grid: {
                        display(chart) {
                            if(visitorData.length===0) return false;
                            const ticksLen = chart.scale.ticks.length;
                            chart.scale.ticks = [chart.scale.ticks[Math.floor(ticksLen*0.3)], chart.scale.ticks[Math.floor(ticksLen*0.7)]];
                            return true;
                        },
                    },
                    ticks: {
                        display: false
                    },
                    position: 'center',
                },        
            },
        };
    
        const data = {
            datasets: [
                {
                    data: visitorData,
                    backgroundColor: visiterRatioList.map((visiter)=>{
                        if(visiter>=80){
                            return '#4c7196';
                        }
                        if(visiter>=30){
                            return '#afd0db';
                        }
                        return '#e4eff0';
                    }),
                    borderRadius: 8,
                },
            ],
        };

        setChartOption({...options});
        setChartData({...data});

    },[visitorData])    

    return (
        <div className="Content-Chart-Wrapper">
            {Object.keys(chartOption).length && Object.keys(chartData).length && <Bar options={chartOption} data={chartData} />}
        </div>
        
    );
}

export default DashboardBarChart;









